<template>
    <div class="chart-container">
        <PieChart :data="chartData" :options="chartOptions" :key="chartKey"/>
    </div>
</template>

<script>
import PieChart from '@/components/customer_insight/Pie'

export default {
    name: "CustomerPieChart",
    components: { PieChart },
    props: {
        valueList: {
            type: Array,
            default: () => []
        }
    },
    watch: {
        valueList() {
            let colorOptions = ['#41B883', '#E46651', '#00D8FF', '#cddb32', '#4652b3', '#c961a1', '#FFC300', '#FF5733', '#C70039', '#900C3F', '#581845']
            let chartLabels = []
            let chartDataset = []
            let chartColors = []
            
            let i = 0
            this.valueList.forEach((value) => {
                if (value.label.length > 13)
                    chartLabels.push(`${value.label.substring(0, 13)}...`)
                else
                    chartLabels.push(value.label)

                chartDataset.push(value.value)
                chartColors.push(colorOptions[i])
                if (i < colorOptions.length - 1)
                    i++
                else
                    i = 0
            })

            this.chartData = {
                labels: chartLabels,
                datasets: [
                    {
                        backgroundColor: chartColors,
                        data: chartDataset
                    }
                ]
            }

            this.chartKey++
        }
    },
    data() {
        return {
            chartOptions: {
                legend: {
                    display: false
                }
            },
            chartData: {},
            chartKey: 0
        }
    }
}
</script>

<style scoped>
.chart-container {
    min-width: 180px;
    width: 600px;
}
</style>